"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var A = function A(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      children = _ref.children,
      newWindow = _ref.newWindow,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$download = _ref.download,
      download = _ref$download === void 0 ? false : _ref$download;

  // NOTE: provide either 'href' or 'onClick' here, but not both
  if (href) {
    var openNewWindow = newWindow || href.startsWith('http');
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "A-a ".concat(className),
      style: style,
      href: href,
      target: openNewWindow ? '_blank' : undefined,
      rel: openNewWindow ? 'nofollow noopener noreferrer' : 'nofollow',
      download: download
    }, children);
  }

  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "A-button ".concat(className),
    onClick: onClick
  }, children);
};

A.propTypes = {
  href: _propTypes.default.string,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  style: _propTypes.default.object,
  download: _propTypes.default.bool
};
var _default = A;
exports.default = _default;